import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {DestinoService} from '../../core/services/destino.service';
import {HotelService} from '../../core/services/hotel.service';

@Component({
    selector: 'app-detalhes-destinos',
    templateUrl: './detalhes-destinos.component.html',
    styleUrls: ['./detalhes-destinos.component.sass']
})
export class DetalhesDestinosComponent implements OnInit {

    constructor(private route: ActivatedRoute,
                private destinoService: DestinoService,
                private hotelService: HotelService,
                private router: Router) {
        this.queryParamData = route.snapshot.params.data;
    }

    public detalheDestino: any;
    public resultHoteis: any;
    images: any[];
    public filteredBrands: any[];
    public brand: any;
    public queryParamData: any;

    async ngOnInit() {
        this.images = [];

        const slug = this.queryParamData;
        this.detalheDestino = this.destinoService.getDetalheDestino(slug);
        const filtro = { numeroPagina: 1, qtdPorPagina: 10, codCidade: this.detalheDestino.id };
        const resultHotel = await this.hotelService.listaHoteis(filtro);
        if (resultHotel.data) {
            this.resultHoteis = resultHotel.data;
        }



        if (this.detalheDestino) {
            this.getGallery();
        }
    }

    public checkExisteRecomendacao(roleParam) {
        return this.detalheDestino.recomendacao.some(({ categoria }) => categoria === roleParam);
    }

    public irParaHotel(item) {
        const param = item.codContrato + '_' + item.slug;
        this.router.navigate(['/hoteis/hotel/', param]);
    }

    public getGallery() {
        this.images = [];

        if (this.detalheDestino.galeriaDeImagens) {
            this.detalheDestino.galeriaDeImagens.forEach(element => {
                this.images.push({ source: element.url });
            });
        }
        return this.images;
    }

    async filterBrands(event) {
        const resultData = await this.hotelService.buscaHoteisAutoComplete(event.query.toLowerCase());
        this.filteredBrands = [];

        resultData.data.paises.forEach(element => {
            this.filteredBrands.push({ tipo: 'paises', data: element });
        });

        resultData.data.estados.forEach(element => {
            this.filteredBrands.push({ tipo: 'estados', data: element });
        });

        resultData.data.cidades.forEach(element => {
            this.filteredBrands.push({ tipo: 'cidades', data: element });
        });

        resultData.data.bairros.forEach(element => {
            this.filteredBrands.push({ tipo: 'bairros', data: element });
        });

        resultData.data.hoteis.forEach(element => {
            this.filteredBrands.push({ tipo: 'hoteis', data: element });
        });
    }

    selectInAutoComplete() {
        if (this.brand.tipo === 'hoteis') {
            this.router.navigate(['/hoteis/hotel/', this.brand.data.id + '_' + this.brand.data.slug]);
        } else if (this.brand.tipo === 'cidades') {
            localStorage.setItem('autocomplete', JSON.stringify(true));
            localStorage.setItem('auto-complete-data', JSON.stringify(this.brand));
            this.router.navigate(['/busca-hoteis'], { queryParams: { codCidade: this.brand.data.id } });
        } else if (this.brand.tipo === 'estados') {
            localStorage.setItem('autocomplete', JSON.stringify(true));
            localStorage.setItem('auto-complete-data', JSON.stringify(this.brand));
            this.router.navigate(['/busca-hoteis'], { queryParams: { codEstado: this.brand.data.id } });
        } else if (this.brand.tipo === 'paises') {
            localStorage.setItem('autocomplete', JSON.stringify(true));
            localStorage.setItem('auto-complete-data', JSON.stringify(this.brand));
            this.router.navigate(['/busca-hoteis'], { queryParams: { codPais: this.brand.data.id } });
        }
    }

    getDetalheAutoComplete(autocomplete) {
        let detalhe = '';
        if (autocomplete.tipo === 'estados') {
            detalhe = autocomplete.data.pais;
        } else if (autocomplete.tipo === 'cidades') {
            detalhe = autocomplete.data.codEstado;
        } else if (autocomplete.tipo === 'bairros') {
            detalhe = autocomplete.data.cidade + ' - ' + autocomplete.data.codEstado;
        } else if (autocomplete.tipo === 'hoteis') {
            detalhe = autocomplete.data.cidade + ' - ' + autocomplete.data.codEstado;
        }
        return detalhe;
    }

    getNomeAutoComplete(autocomplete) {
        let detalhe = '';
        if (autocomplete.tipo === 'estados') {
            detalhe = autocomplete.data.nome + ' (UF)';
        } else {
            detalhe = autocomplete.data.nome;
        }
        return detalhe;
    }

    getQuantidadeHoteis(autocomplete) {
        let quantidade = '';
        if (autocomplete.tipo !== 'hoteis') {
            if (autocomplete.data.quantidade > 1) {
                quantidade = autocomplete.data.quantidade + ' hoteis';
            } else {
                quantidade = autocomplete.data.quantidade + ' hotel';
            }
        }

        return quantidade;
    }

    scroll(el) {

        const yOffset = -150;
        const element = document.getElementById(el);
        const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;

        window.scrollTo({ top: y, behavior: 'smooth' });
    }
}
